import * as React from 'react';

const PrivateSteppingContext = /*#__PURE__*/ React.createContext(null);
/**
 * This hook is not exported outside of this module. It is not meant to be used by consumers.
 */ const usePrivateSteppingContext = ()=>{
    const context = React.useContext(PrivateSteppingContext);
    if (context === null) {
        throw Error(`Consumer of useSteppingContext needs to be wrapped in a PrivateSteppingContext provider.`);
    }
    return context;
};
const PrivateSteppingContextProvider = ({ children , configuratorId , stepsMap , stepSequence , lastStepCTALabelKey , footerTopBarContent , footerExpanderContent ,  })=>{
    const id = configuratorId;
    const selectorProps = React.useMemo(()=>({
            id,
            stepsMap,
            stepSequence
        })
    , [
        id,
        stepsMap,
        stepSequence
    ]);
    const context = {
        selectorProps,
        configuratorId,
        stepsMap,
        lastStepCTALabelKey,
        footerExpanderContent,
        footerTopBarContent
    };
    return /*#__PURE__*/ React.createElement(PrivateSteppingContext.Provider, {
        value: context
    }, children);
};

export { PrivateSteppingContext, PrivateSteppingContextProvider, usePrivateSteppingContext };
//# sourceMappingURL=PrivateSteppingContext.js.map
